import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function usePermissionsApi() {
  const callApi = useApiCall();

  const getPermissions = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS, data, onSuccess, onError);
  };

  const getPermissionsMatrix = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS_MATRIX, data, onSuccess, onError);
  };

  const getPermissionsModuleJobs = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS_MODULE_JOBS, data, onSuccess, onError);
  };

  return {
    callGetPermissions: getPermissions,
    callGetPermissionsMatrix: getPermissionsMatrix,
    callGetPermissionsModuleJobs: getPermissionsModuleJobs,
  };
}
